module.exports = __webpack_public_path__ + "img/主页1.e8c82e5f.jpg";